/** Only allow in-app absolute paths to avoid open redirects (`//evil.com`, `https://…`). */
export function safeReturnTo(search: string): string {
  const value = new URLSearchParams(search).get('returnTo');
  if (!value?.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return '/';
  return value;
}
